import {PropertyType} from 'common/report/constants';
import {DateRangeAttributes} from 'common/widgets/date-range-picker/models/date-range';
import {DateRangeType} from 'common/widgets/date-range-picker/models/types';
import type {CohortSegment} from 'common/query-builder/query-block/segment-menu/types';

export enum ListQuantifier {
  // for filters
  Any = `any`,
  All = `all`,
  /** for breakdowns ([tech spec](https://www.notion.so/mxpnl/Breakdown-QApi-Implementation-d35e842315024db78e10f72c179878b2)) */
  Flatten = `flatten`,
}

export enum SCDOptionsType {
  /** If any value of the SCD property within the date range matches */
  Any = `any`,
  /** If the latest value *as of event time* of the SCD property matches */
  Latest = `latest`,
  /** SCD value on a particular date */
  Fixed = `fixed`,
}

export const PropertyTypeSet = new Set(Object.values(PropertyType));

// TODO: This is model representation. These are also used as the display names
// in the UI. There should be a mapping from model representation to display names as
// the model shouldn't change, but the display names can.

export enum StringOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
  DoesNotEqual = `does not equal`,
  Equals = `equals`,
  NotSet = `is not set`,
  Set = `is set`,
}

export enum ObjectOperator {
  Equals = `equals`,
  Set = `is set`,
}

export enum NumberOperator {
  AtLeast = `is at least`,
  Between = `is between`,
  NotBetween = `is not between`,
  EqualTo = `is equal to`,
  NotEqualTo = `is not equal to`,
  GreaterThan = `is greater than`,
  LessThan = `is less than`,
  AtMost = `is at most`,
  Set = `is set`,
  NotSet = `is not set`,
}

export enum ListOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
}

export enum BooleanOperator {
  True = `true`,
  False = `false`,
}

export enum BooleanFilterOperator {
  True = `is true`,
  False = `is false`,
}

export enum CohortOperator {
  In = `in`,
  NotIn = `not in`,
}

export const CohortOperatorListMap = {
  [CohortOperator.In]: ListOperator.Contains,
  [CohortOperator.NotIn]: ListOperator.DoesNotContain,
};

export enum LogicalOperator {
  And = `and`,
  Not = `not`,
  Or = `or`,
}

export enum NthTimeOperator {
  NthTime = `nth time`,
  FirstTimeInPeriod = `first time in period`,
  LastTimeInPeriod = `last time in period`,
}

export type FilterOperator =
  | StringOperator
  | NumberOperator
  | DateRangeType
  | ListOperator
  | BooleanOperator
  | ObjectOperator
  | LogicalOperator
  | NthTimeOperator;

// TODO(micah): the Partial<DateRangeAttributes> is wrong, filter value shouldn't be partial. but the types are messed up in cohorts transformations as it has a conflicting date type
export type FilterOperand = string | boolean | number | Partial<DateRangeAttributes> | CohortSegment;
export type FilterValue = FilterOperand | FilterOperand[];

export enum DisplayContext {
  Cohorts = `cohorts`,
  CustomEvent = `custom_event`,
  Default = `default`,
  Insights = `insights`,
  Signal = `signal`,
}
